module.exports = __webpack_public_path__ + "static/media/29ADMSPC15.ce49fb16.jpg";